import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import { IconButton } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import LoginService from "../../services/loginService";
import BackdropLoaderService from "../BackdropLoader/backdropLoaderService";
import { COLLECTION_TAB } from "../../pages/MyProfile/MyProfile";
import { COLLECTION_SECTION } from "../../pages/MyProfile/Collection/Collection";
import RedirectService from "../../services/redirectService";

const GoogleSignIn = () => {
  const navigate = useNavigate();

  const { setGoogleLogin } = LoginService();
  const { open: openBDL, close: closeBDL } = BackdropLoaderService();

  const handleSuccessGoogleLogin = async (token: string) => {
    const { hasRedirectUrl } = RedirectService();
    const responseOk = await setGoogleLogin(token);
    closeBDL();
    if (responseOk) {
      closeBDL();
      // Only navigate to default profile if there's no redirect URL stored
      if (!hasRedirectUrl()) {
        navigate(
          "/my-profile/" +
            responseOk.user?.id +
            "/" +
            COLLECTION_TAB.COLLECTION +
            "/" +
            COLLECTION_SECTION.OVERVIEW
        );
      }
      // If there is a redirect URL, the storeLogin function will handle the navigation
    }
  };

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) =>
      handleSuccessGoogleLogin(tokenResponse.access_token),
  });

  return (
    <IconButton
      onClick={() => {
        openBDL();
        login();
      }}
      sx={{
        backgroundColor: "#4663ff",
        color: "white",
        width: "35px",
        height: "35px",
      }}
    >
      <GoogleIcon />
    </IconButton>
  );
};

export default GoogleSignIn;
